<template>
  <div class='collection'>
    <div class="goods-item">
      <div class="goods-img">
        <img class="img" :src="goodsItem.pic">
      </div>
      <div class="goods-content">
        <div class="title">{{goodsItem.name}}</div>
        <div class="price-wrapper">
          <div class="price">
            <span>¥</span>{{(goodsItem.mini_price / 100).toFixed(2)}}
          </div>
          <div class="detail">查看详情</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="span/ecmascript-6">
export default {
  name: 'Goods',
  props: {
    goodsItem: {
      type: Object,
      default: () => { },
    },
  },
  data () {
    return {

    }
  },
  methods: {},
  mounted () { },
}
</script>

<style scoped lang="stylus">
.collection
  width 345px
  height 134px
  background linear-gradient(141deg, rgba(255, 155, 0, 1) 0%, rgba(255, 62, 0, 1) 100%)
  border-radius 6px
  padding 5px
  .goods-item
    display flex
    justify-content space-between
    box-sizing border-box
    position relative
    margin-bottom 15px
    padding 20px 15px
    width 335px
    height 124px
    background #fff
    border-radius 4px
    .goods-img
      width 134px
      height 84px
      .img
        width 100%
        height 100%
    .goods-content
      display flex
      flex-direction column
      justify-content space-between
      width 158px
      height 84px
      font-size 14px
      .title
        width 158px
        height 42px
        line-height 21px
        font-size 14px
        color #404040
        overflow hidden
        text-overflow ellipsis
        display -webkit-box
        -webkit-line-clamp 2
        -webkit-box-orient vertical
      .price-wrapper
        display flex
        justify-content space-between
        .price
          font-size 16px
          color #E50113
          position relative
          top 5px
          text
            font-size 14px
        .detail
          width 78px
          height 31px
          line-height 31px
          text-align center
          font-size 12px
          color #fff
          background url('~@/assets/template/mobile-goods-btn.png') no-repeat center
          background-size 78px 31px
</style>



// WEBPACK FOOTER //
// src/components/content/modal/Goods.vue